var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { TemplateService } from "~/services/domain-service/template.service";
import { Emit, Prop } from "vue-property-decorator";
var ModifyMessageTemplete = /** @class */ (function (_super) {
    __extends(ModifyMessageTemplete, _super);
    function ModifyMessageTemplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messageModel = {
            templateCode: "",
            templateName: "",
            templateStatus: "ENABLED",
            templateContent: "",
            templateCategory: "MESSAGE",
            isDefault: "NO",
        };
        _this.rules = {
            templateCode: { required: true, message: "请输入模板编号" },
            templateName: { required: true, message: "请输入模板名称" },
            templateStatus: { required: true, message: '请选择模板状态' },
            templateContent: { required: true, message: '请输入短信内容' }
        };
        return _this;
    }
    ModifyMessageTemplete.prototype.refresh = function () {
        if (!this.selectedRow) {
            var templateForm = this.$refs["form"];
            templateForm.resetFields();
            this.messageModel.id = '';
        }
        else {
            this.messageModel.templateCode = this.selectedRow.templateCode;
            this.messageModel.templateName = this.selectedRow.templateName;
            this.messageModel.templateStatus = this.selectedRow.templateStatus;
            this.messageModel.isDefault = this.selectedRow.isDefault;
            this.messageModel.templateContent = this.selectedRow.templateContent;
            this.messageModel.id = this.selectedRow.id;
        }
    };
    ModifyMessageTemplete.prototype.refreshData = function () { };
    ModifyMessageTemplete.prototype.close = function () {
    };
    /**
     * 提交新建模板按钮
     */
    ModifyMessageTemplete.prototype.commit = function (type) {
        var _this = this;
        var templateForm = this.$refs["form"];
        templateForm.validate(function (validate) {
            if (!validate)
                return;
            _this.templateService.createTemplate(_this.messageModel).subscribe(function () {
                _this.refreshData();
                _this.close();
                templateForm.resetFields();
                _this.$message.success('操作成功');
            });
        });
    };
    __decorate([
        Dependencies(TemplateService)
    ], ModifyMessageTemplete.prototype, "templateService", void 0);
    __decorate([
        Prop()
    ], ModifyMessageTemplete.prototype, "selectedRow", void 0);
    __decorate([
        Emit('refreshData')
    ], ModifyMessageTemplete.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], ModifyMessageTemplete.prototype, "close", null);
    ModifyMessageTemplete = __decorate([
        Component({
            components: {}
        })
    ], ModifyMessageTemplete);
    return ModifyMessageTemplete;
}(Vue));
export default ModifyMessageTemplete;
